import React, { useContext } from "react";
import { Navigate, type To } from "react-router";
import { SsrRouterContext } from "./ssrRouterContext";

type RedirectTarget = string | { pathname?: string; search?: string; hash?: string; state?: unknown };

function toPath(to: RedirectTarget): { to: To; state?: unknown; url: string } {
	if (typeof to === "string") {
		return { to, url: to };
	}
	const pathname = to.pathname ?? "";
	const search = to.search ?? "";
	const hash = to.hash ?? "";
	return {
		to: { pathname, search, hash },
		state: to.state,
		url: `${pathname}${search}${hash}`,
	};
}

/** v5 `<Redirect>` replacement. Replaces the history entry, and records the target during SSR. */
export const Redirect: React.FC<{ to: RedirectTarget }> = ({ to }) => {
	const ssrContext = useContext(SsrRouterContext);
	const target = toPath(to);

	if (ssrContext) {
		ssrContext.statusCode = 301;
		ssrContext.url = target.url;
		return null;
	}

	return <Navigate to={target.to} state={target.state} replace />;
};
